export const IconAlarm = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <mask
        id="IconAlarm_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconAlarm_svg__a)">
        <path d="M13 12.6V9a.97.97 0 0 0-.287-.712A.97.97 0 0 0 12 8a.97.97 0 0 0-.713.288A.97.97 0 0 0 11 9v3.975q0 .2.075.388.075.187.225.337l2.8 2.8a.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7zM12 22q-1.874 0-3.512-.712a9.2 9.2 0 0 1-2.85-1.925 9.2 9.2 0 0 1-1.925-2.85A8.7 8.7 0 0 1 3 13q0-1.874.713-3.512a9.2 9.2 0 0 1 1.925-2.85 9.2 9.2 0 0 1 2.85-1.925A8.7 8.7 0 0 1 12 4q1.874 0 3.512.713a9.2 9.2 0 0 1 2.85 1.925 9.2 9.2 0 0 1 1.926 2.85A8.7 8.7 0 0 1 21 13q0 1.874-.712 3.512a9.2 9.2 0 0 1-1.925 2.85 9.2 9.2 0 0 1-2.85 1.926A8.7 8.7 0 0 1 12 22M2.05 7.3a.95.95 0 0 1-.275-.7q0-.425.275-.7L4.9 3.05a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L3.45 7.3a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275m19.9 0a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275L17.7 4.45a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l2.85 2.85a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7M12 20q2.925 0 4.962-2.038T19 13t-2.038-4.962T12 6 7.038 8.038 5 13t2.038 4.962T12 20" />
      </g>
    </svg>
  );
};
